module.exports = __webpack_public_path__ + "static/media/flag-rw.738cb6ce.webp";